import React from "react";
import PouchInput from "components/PouchInput";
import PouchDateInput from "components/PouchDateInput";
import PouchSelect from "components/PouchSelect";
import SortableHeaderCell from "components/SortableHeaderCell";
import { Column } from "components/table/Table";
import { Meet } from "types";
import get from "lodash/get";

const RestrictedCell = ({
  data,
  column,
  meet,
  style,
}: {
  data: any;
  column: Column;
  meet: Meet;
  style: React.CSSProperties;
}) => {
  const lifter = data;
  if (lifter.row === "header") {
    return <SortableHeaderCell style={style} column={column} />;
  } else {
    const restrictedDoc = get(lifter, "restricted", {});
    if (column.type === "select") {
      if (!column.options) {
        return null;
      }
      return (
        <div style={style} className="table-cell-inner">
          <PouchSelect
            meet={meet}
            document={restrictedDoc}
            name={column.key}
            value={get(restrictedDoc, column.key)}
            options={column.options}
          />
        </div>
      );
    } else if (column.type === "date") {
      return (
        <div style={style} className="table-cell-inner">
          <PouchDateInput
            meet={meet}
            documentId={restrictedDoc._id}
            name={column.key}
            value={get(restrictedDoc, column.key)}
          />
        </div>
      );
    } else {
      return (
        <div style={style} className="table-cell-inner">
          <PouchInput
            type={column.type === "number" ? "number" : "text"}
            meetId={meet._id}
            documentId={restrictedDoc._id}
            name={column.key}
            value={get(restrictedDoc, column.key)}
          />
        </div>
      );
    }
  }
};

export default RestrictedCell;
